export default __webpack_public_path__ + "static/media/yellow_blob_1.cc1585d7.png";